module.exports = new __parcel__URL__("gallery_9.1ffcbc79.jpg").toString();